import ResetPasswordScene from './ResetPasswordScene'
export default ResetPasswordScene